/** Continental US centroid — stable fallback when no saved view, pins, GPS, or company geocode. */
export const LEADS_MAP_CONTINENTAL_US = {
  center: [39.8283, -98.5795],
  zoom: 4,
};

/** Zoom used when falling back to company HQ geocode. */
export const LEADS_MAP_HQ_ZOOM = 8;

export function leadHasMapCoordinates(lead) {
  if (!lead) return false;
  const lat = Number(lead.latitude ?? lead.lat);
  const lng = Number(lead.longitude ?? lead.lng);
  return (
    Number.isFinite(lat) &&
    Number.isFinite(lng) &&
    Math.abs(lat) <= 90 &&
    Math.abs(lng) <= 180
  );
}

/** Company profile HQ camera, or null if coords are missing/invalid. */
export function parseCompanyMapDefault(profile) {
  const lat = Number(profile?.map_default_latitude);
  const lng = Number(profile?.map_default_longitude);
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
  if (Math.abs(lat) > 90 || Math.abs(lng) > 180) return null;
  return { center: [lat, lng], zoom: LEADS_MAP_HQ_ZOOM };
}

export function leadsMapLastViewStorageKey(userId) {
  if (userId == null || userId === "") return null;
  return `tc_leads_map_last_${userId}`;
}

export function readLeadsMapLastView(userId) {
  const key = leadsMapLastViewStorageKey(userId);
  if (!key || typeof window === "undefined") return null;
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    const o = JSON.parse(raw);
    const lat = Number(o.lat);
    const lng = Number(o.lng);
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
    if (Math.abs(lat) > 90 || Math.abs(lng) > 180) return null;
    let zoom = Number(o.zoom);
    if (!Number.isFinite(zoom)) zoom = 8;
    zoom = Math.min(18, Math.max(3, zoom));
    return { center: [lat, lng], zoom };
  } catch {
    return null;
  }
}

export function writeLeadsMapLastView(userId, center, zoom) {
  const key = leadsMapLastViewStorageKey(userId);
  if (!key || typeof window === "undefined") return;
  try {
    localStorage.setItem(
      key,
      JSON.stringify({
        lat: center[0],
        lng: center[1],
        zoom,
      })
    );
  } catch {
    /* quota / private mode */
  }
}
